/**
 * Section navigation scroll spy (menu_section layout 2).
 *
 * Marks the link of the section currently in view. An IntersectionObserver watches the anchors the
 * menu points at (#c<uid>, the id the Default layout puts on every content element) with a root
 * margin that shrinks the viewport to a band near the top, so the "current" section is the one the
 * reader has just reached rather than whatever happens to be largest on screen.
 *
 * Degrades to a plain list of links: without JavaScript nothing is marked, every link still works.
 */
document.addEventListener('alpine:init', () => {
    Alpine.data('sectionNav', () => ({
        current: null,
        _observer: null,
        _visible: new Set(),

        init() {
            const targets = Array.from(this.$root.querySelectorAll('[data-section]'))
                .map((link) => document.getElementById(link.dataset.section))
                .filter(Boolean);

            if (!targets.length || !('IntersectionObserver' in window)) {
                return;
            }

            // First section is current until the reader scrolls past it.
            this.current = targets[0].id;

            this._observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    entry.isIntersecting ? this._visible.add(entry.target.id) : this._visible.delete(entry.target.id);
                });

                // Of everything in the band, take the one that comes first in document order.
                const first = targets.find((target) => this._visible.has(target.id));
                if (first) {
                    this.current = first.id;
                }
            }, {
                // Band from just under the sticky header down to 60% of the viewport.
                rootMargin: '-15% 0px -60% 0px',
                threshold: 0,
            });

            targets.forEach((target) => this._observer.observe(target));
        },

        isCurrent(id) {
            return this.current === id;
        },

        destroy() {
            if (this._observer) {
                this._observer.disconnect();
            }
        },
    }));
});
